<div class="vtr-hardware-components">
	<div class="row header-content">
		<div class="col col-12">
			<vtr-hardware-scan-header-pages
				[percent]="getProgress()"
				[disableButtonScan]="isStartScanClicked() || isRefreshingModules()"
				(checkCancel)="onCancelScan()"
				[disableCancel]="isDisableCancel()"
				(checkAnchor)="startScanWaitingModules(taskTypeEnum.CustomScan)"
				(startQuickScan)="startScanWaitingModules(taskTypeEnum.QuickScan)"
				(scanAgain)="scanAgain()"
				[completed]="completedStatus"
				[deviceInRecover]="deviceInRecover">
			</vtr-hardware-scan-header-pages>
		</div>
	</div>

	<div class="body-content">
		<div class="row px-0">
			<div class="col-12 header">
				<h2 id="hwscan-components-title" role="heading" class="heading2">{{getComponentsTitle()}}</h2>

				<!-- Link Refresh Modules -->
				<vtr-ui-hyperlink-button class="export-and-refresh-button"
					linkId="hwscan-refresh-modules-btn"
					linkRole="button"
					*ngIf="!isRefreshingModules() && !isScanExecuting() && !isRecoverExecuting()"
					hyperlinkStyle="xs-300-lightGray1"
				 	[isDisabled]="disableRefreshAnchor()"
				 	[faIcon]="['fal', 'redo']"
					[label]="'hardwareScan.refreshModule' | translate"
					(hyperlinkClick)="refreshModules()">
				</vtr-ui-hyperlink-button>

				<!-- Link Export Results -->
				<vtr-ui-hyperlink-button
					*ngIf="isFeatureExportAvailable"
					class="export-and-refresh-button"
					linkId="hwscan-export-log-btn"
					linkRole="button"
					hyperlinkStyle="xs-300-blue-lighter"
					imgIconSrc="{{ getExportIcon( !isExportLogAvailable() ) }}"
					[isDisabled]="!isExportLogAvailable()"
					(hyperlinkClick)="exportLog()"
					[label]="'hardwareScan.exportLog' | translate">
				</vtr-ui-hyperlink-button>
			</div>
		</div>

		<div class="row">
			<div class="col">
				<div class="hardware-lists-container">
					<vtr-widget-hardware-scan-item
						*ngIf="!isRefreshingModules()"
						[items]="modules"
						[resultCodeText]="'hardwareScan.resultCode' | translate"
						[isScanExecute]="isScanExecuting()"
						[isRecoverExecute]="isRecoverExecuting()"
						[isEnableViewResults]="getEnableViewResults()">
					</vtr-widget-hardware-scan-item>

					<div class="loading-components" *ngIf="isRefreshingModules() && !isRecoverExecuting()">
						<fa-icon id="hwscan-refresh-modules-spinner" [attr.aria-label]="'Loading Icon'" role="img" placement="auto" [spin]="true" [icon]="['fal', 'circle-notch']" container="vtr-root">
						</fa-icon>
					</div>

					<div id="hwscan-refresh-modules-message" role="text" class="refresh-message" *ngIf="isRefreshingModules() && !isRecoverExecuting()" aria-live="polite">
						{{ 'hardwareScan.refreshMessage' | translate }}
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
